import { useQuery } from "@tanstack/react-query";

// Loads the full lucide set once per session; every consumer shares the cache.
export default function useLucideIcons() {
  return useQuery({
    queryKey: ["lucide-icon-set"],
    queryFn: () => import("components/icons/lucideIconSet"),
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
